import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {inputStyles} from "@/components/input/input.styles.ts";
import {RequiredValidator, Validator} from "@/components/validators/validators.ts";
import {AutocompleteMixin, SuggestItem} from "@/components/autocomplete/autocomplete-mixin.ts";
import {autocompleteStyles} from "@/components/autocomplete/autocomplete.styles.ts";
import {labelStyles} from "@/components/label/label.styles.ts";



@customElement('sbk-autocomplete-input-zip')
export class SbkAutocompleteInputZip extends AutocompleteMixin(LitElement) {

  validatorMapper: {
    [key: string]: Validator
  } = {
    'required': RequiredValidator,
  }

  static get styles() {
    return [
      autocompleteStyles,
      labelStyles,
      inputStyles
    ];
  }

  async _querySuggestions(inputValue: string) {
    if (inputValue.length < 3) {
      this.suggestions = [];
      this.close(true)
      return;
    }
    await fetch('/ajax/middleware/searchAddress' + '?' + new URLSearchParams({
      "zipCode": inputValue.toLowerCase(),
    }))
        .then((response) => {
          return response.text()
        })
        .then((data) => {
          const parsedSuggestions = JSON.parse(data);
          const allSuggestions: SuggestItem[] = [];
          Object.entries(parsedSuggestions).forEach((suggestion) => {
            allSuggestions.push( {
              label: suggestion[0],
              value: <string> suggestion[1]
            } );
          });
          this.suggestions = allSuggestions;
        })
    await this.updateComplete;
  }
}